import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";
import { MuiAvatar } from "./avatar";
import { MuiButton, MuiToggleButton, MuiToggleButtonGroup, MuiIconButton } from "./button";
import { MuiCard } from "./card";
import { MuiChip } from "./chip";
import { MuiCardActions } from "./card-actions";
import { MuiCardContent } from "./card-content";
import { MuiCardHeader } from "./card-header";
import { MuiDataGrid } from "./data-grid";
import { MuiDialog, MuiDialogActions, MuiDialogContent, MuiDialogTitle } from "./dialog";
import { MuiLink } from "./link";
import { MuiStack } from "./stack";
import { MuiTab } from "./tab";
import {
  MuiTextField,
  MuiFormControl,
  MuiAutocomplete,
  MuiCheckbox,
  MuiRadio,
  MuiSwitch,
} from "./form-inputs";

export const components = {
  MuiAvatar,
  MuiCard,
  MuiCardContent,
  MuiCardHeader,
  MuiCardActions,
  MuiDialog,
  MuiDialogTitle,
  MuiDataGrid,
  MuiDialogContent,
  MuiDialogActions,
  MuiLink,
  MuiStack,
  MuiTab,
  MuiButton,
  MuiToggleButton,
  MuiToggleButtonGroup,
  MuiIconButton,
  MuiCheckbox,
  MuiChip,
  MuiTextField,
  MuiFormControl,
  MuiAutocomplete,
  MuiRadio,
  MuiSwitch,
} satisfies Components<Theme>;
